export default __webpack_public_path__ + "static/gap-logo-535e2923880c4741a7e47e21ac98baaf.png";